import React from 'react';

function BuildingEight({ fill, ...restProps }) {
  return (
    <>
      <svg
        fill={fill ?? ''}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        {...restProps}
      >
        <path
          d='M11.736 1.12c-.09.018-.234.063-.32.099-.268.111-7.987 4.953-8.141 5.106a.986.986 0 0 0-.263.776c.027.26.106.419.312.618.314.305-.412.281 8.693.279 6.715-.001 8.19-.011 8.313-.055.684-.244.889-1.129.377-1.625-.2-.194-7.832-4.972-8.147-5.101-.258-.106-.593-.145-.824-.097m2.537 3.48 2.207 1.38-2.24.01c-1.232.006-3.248.006-4.48 0l-2.24-.01 2.21-1.387c1.216-.763 2.238-1.384 2.273-1.38.035.004 1.056.628 2.27 1.387M5.67 9.061c-.222.081-.42.248-.542.455L5.02 9.7v8.606l.121.197a.998.998 0 0 0 1.718 0l.121-.197V9.7l-.108-.184c-.248-.422-.762-.617-1.202-.455m4 0c-.222.081-.42.248-.542.455L9.02 9.7v8.606l.121.197a.998.998 0 0 0 1.718 0l.121-.197V9.7l-.108-.184c-.248-.422-.762-.617-1.202-.455m4 0c-.222.081-.42.248-.542.455l-.108.184v8.606l.121.197a.998.998 0 0 0 1.718 0l.121-.197V9.7l-.108-.184c-.248-.422-.762-.617-1.202-.455m4 0c-.222.081-.42.248-.542.455l-.108.184v8.606l.121.197a.998.998 0 0 0 1.718 0l.121-.197V9.7l-.108-.184c-.248-.422-.762-.617-1.202-.455M2.695 20.057a1.04 1.04 0 0 0-.567.459c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.223.08 18.437.08 18.66 0 .221-.079.414-.241.539-.454.095-.161.111-.233.111-.489 0-.254-.017-.328-.108-.484a1.02 1.02 0 0 0-.582-.461c-.263-.079-18.343-.077-18.595.002'
          fill-rule='evenodd'
          fill={fill ?? ''}
        />
      </svg>
    </>
  );
}

export default BuildingEight;
